import { Text } from '@mantine/core';
import { CampusRegistrationsListView } from './Components/CampusRegistrationsListView';
import { useCampusParam } from '@/hooks/useCampusParam';

export default function CampusRegistrationPage() {
  const { campus, campusLabel, allowed } = useCampusParam();

  if (!allowed) {
    // swap for your existing access-denied panel
    return <Text c="red" p="xl">You do not have access to {campusLabel} registrations.</Text>;
  }

  return (
    <CampusRegistrationsListView
      key={campus}
      campus={campus}
      title={`${campusLabel} Registrations`}
      subtitle="View course registrations for your campus."
    />
  );
}
